
import Button from 'react-bootstrap/Button';
import { AthleteContext } from '../context/athelete';
import { useContext, useEffect, useState } from 'react';

//material-ui
import RefreshIcon from '@material-ui/icons/Refresh';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PageViewIcon from '@material-ui/icons/Pageview';
import VerifiedIcon from '@material-ui/icons/VerifiedUser';
import { isMemberOf, Loading, PaginatedTable } from '../common/variables';
import { CoachContext } from '../context/coach';
import { AppContext } from '../context/app';
import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger';
import Tooltip from 'react-bootstrap/esm/Tooltip';

export function ClubProfile(){
    const { athleteState : {athletes} , getAthletesForClub , getAthletesForSchool} = useContext(AthleteContext);
    const { coachState : {coaches}  , getCoachesForClub} = useContext(CoachContext);
    const { appState : { userProfile , user : { groups }} , setCurrentView , setAtheleteInView} = useContext(AppContext);
    const [loading , setLoading] = useState(true);
    useEffect(()=>{
      if(!userProfile.club){
        return;
      }
      try{
        getCoachesForClub(userProfile.club.id);
        if(userProfile.club.organization_type.toLowerCase() === "club"){
          getAthletesForClub(userProfile.club.id);
        }
        else if(userProfile.club.organization_type.toLowerCase() === "school"){
          getAthletesForSchool(userProfile.club.id);
        }
      }
      finally{
        setTimeout(()=>setLoading(false) ,500);
      }
    },[userProfile]);
    return(
      <div className="mr-2 p-2">
        <div className="d-flex mb-3 justify-content-between">
            <h4>Club Profile</h4>
            <div className="d-flex align-items-center">
                <Button size="sm" variant="outline-success"  ><RefreshIcon/></Button>
            </div>
        </div>
        {
          loading ? <Loading/> :
          <>
          { userProfile.club && <h5  className="mb-3">{userProfile.club.name}</h5>}
          <h6>Coaches</h6>
          <PaginatedTable striped bordered
            thead={<tr><th>ID Number</th><th>First Name</th><th>Last Name</th><th>Email</th></tr>}
            items={coaches}
            renderRowAs={({item:coach})=>
                  <tr key={coach.id}>
                    <td>{coach.id}</td>
                    <td>{coach.first_name}</td>
                    <td>{coach.last_name}</td>
                    <td>{coach.email}</td>
                  </tr>
            }
            renderEmpty={<tr><td colSpan={4} style={{padding : 4 , textAlign : "center"}}>No Coaches to display</td></tr>}
            perPage={10}
            />
          </>
        }
        {
          loading ? <Loading/> :
          <>
            <h6>Athletes</h6>
            <PaginatedTable striped bordered
              thead={<tr>
                <th>ID Number</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Date of Birth</th>
                <th>Email</th>
                {isMemberOf(groups,'coach') && <th>Club Status</th>}
                {isMemberOf(groups,'coach') && <th>AAB Status</th>}
                {isMemberOf(groups,'coach') && <th/> }
              </tr>}
              items={athletes}
              renderEmpty={<tr><td colSpan={isMemberOf(groups,'coach') ? 8 : 5} style={{textAlign : "center", padding : 8}}>No Athletes to display</td></tr>}
              renderRowAs={({item : athlete})=>
                      <tr key={athlete.id}>
                        <td>{athlete.id}</td>
                        <td>{athlete.first_name}</td>
                        <td>{athlete.last_name}</td>
                        <td>{athlete.dob}</td>
                        <td>{athlete.email}</td>
                        {isMemberOf(groups,'coach') && <td className={athlete.club_verified ? "text-success" : "text-danger"}>{athlete.club_verified ? "Verified" : "Verification requried"}</td>}
                        {isMemberOf(groups,'coach') && <td className={athlete.aab_verified ? "text-success" : "text-danger"}>{athlete.aab_verified ? "Resigtered" : "Registration Pending"}</td>}
                        {
                          isMemberOf(groups,'coach') && 
                          <td style={{textAlign : "center"}}>
                            <Button size="sm" className="ml-1" variant="outline-info" onClick={()=>{setCurrentView(`#athleteDetails?a=${athlete.id}`) ; setAtheleteInView(athlete)}}>
                              <OverlayTrigger placement="top" overlay={<Tooltip>{true&&"View Details"}</Tooltip>}>
                                <PageViewIcon style={{fontSize :"1rem"}}/>
                              </OverlayTrigger>
                            </Button>
                          {
                            !athlete.aab_verified &&
                            <Button size="sm" className="ml-1" variant="outline-primary">
                              <OverlayTrigger placement="top" overlay={<Tooltip>{athlete.aab_verified ? "Verified" : "Verification requried"}</Tooltip>}>
                                <VerifiedIcon style={{fontSize :"1rem"}}/>
                              </OverlayTrigger>
                            </Button>
                          }
                          {
                            athlete.club_verified  && 
                            <Button size="sm" className="ml-1" variant="outline-danger">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Remove from club</Tooltip>}>
                                <ExitToAppIcon style={{fontSize :"1rem"}}/>
                            </OverlayTrigger>
                          </Button>
                          }
                        </td>}
                      </tr>}
                perPage={10}
                />
          </>
         }
      </div>
    )
  }